import { action, observable } from 'mobx';

export enum Drawer {
  Notifications = 'notifications',
  Switcher = 'switcher',
  None = 'none',
}

export default class DrawerStore {
  @observable currentDrawer: Drawer = Drawer.None;

  @action
  closeDrawer() {
    this.currentDrawer = Drawer.None;
  }

  @action
  openDrawer(drawer: Drawer) {
    this.currentDrawer = drawer;
  }
}
